import React from 'react';
import PropTypes from 'prop-types';

import { VIDEO_STATUS } from '../shared/status_descriptions';

export const VideoStatus = props => {
  const { CreativeService: { creative: { status } } } = props;
  const videoStatus = VIDEO_STATUS[status];

  if (!videoStatus) {
    return <></>;
  }

  return (
    <div>
      <span className="text-muted">{videoStatus.isError ? 'Error' : 'Status'}:</span>
      {' '}{videoStatus.description}
    </div>
  );
};

VideoStatus.propTypes = {
  CreativeService: PropTypes.shape({
    creative: PropTypes.shape({
      status: PropTypes.string,
    }).isRequired,
    set: PropTypes.func.isRequired,
    setBehavior: PropTypes.func
  }).isRequired,
};
